import { CookiesProvider } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';

import { Toaster } from '@shared';

import { GoogleOAuthProvider, QueryProvider, RouterProvider } from '@/app/provider';
import { InterestProvider } from '@/features/interest';
import { AuthProvider } from '@/router/AuthContext';

import { ThemeProvider } from './ThemeProvider';

import './App.css';

function App() {
  return (
    <HelmetProvider>
      <QueryProvider>
        <GoogleOAuthProvider>
          <AuthProvider>
            <CookiesProvider>
              <ThemeProvider>
                <InterestProvider>
                  <Toaster />
                  <RouterProvider />
                </InterestProvider>
              </ThemeProvider>
            </CookiesProvider>
          </AuthProvider>
        </GoogleOAuthProvider>
      </QueryProvider>
    </HelmetProvider>
  );
}

export default App;
